import React from "react";
import { Link } from "react-router-dom";
import AdminPageHeader from "../../components/AdminPageHeader";
import useUserRole from "../../hooks/useUserRole";
import useRolePermissions from "../../hooks/useRolePermissions";

function Card({ to, title, hint }) {
  return (
    <Link
      to={to}
      className="adminModuleCard"
      style={{ textDecoration: "none" }}
    >
      <div className="adminModuleTitle">{title}</div>
      <div className="adminModuleHint">{hint}</div>
    </Link>
  );
}

export default function PayrollHome() {
  const { role, loading: roleLoading } = useUserRole();
  const { can, loading: permsLoading } = useRolePermissions(role);

  if (roleLoading || permsLoading) {
    return <div style={{ padding: 20 }}>Loading…</div>;
  }

  const canSeeAnything =
    can("TimeCardsRead") || can("EditPunches") || can("PayRates");

  if (!canSeeAnything) {
    return (
      <div style={{ padding: 20 }}>
        <AdminPageHeader title="Payroll" />
        <p>You do not have access to this page.</p>
      </div>
    );
  }

  return (
    <div style={{ padding: 20 }}>
      <AdminPageHeader title="Payroll" />

      <div style={{ color: "#64748b", marginTop: -8, marginBottom: 18 }}>
        Payroll summary, time cards, punch corrections, and pay rates
      </div>

      <div className="adminModuleGrid">
        {can("TimeCardsRead") && (
          <Card
            to="/admin/payroll/summary"
            title="Payroll Summary"
            hint="Yearly payroll export, filters, totals, print, and Excel download"
          />
        )}

        {can("TimeCardsRead") && (
          <Card
            to="/admin/timecards"
            title="Time Cards"
            hint="View and print time cards"
          />
        )}

        {can("EditPunches") && (
          <Card
            to="/admin/edit-punches"
            title="Edit Punches"
            hint="Correct punch entries with audit trail"
          />
        )}

        {can("PayRates") && (
          <Card
            to="/admin/system/pay-rates"
            title="Set Pay Rates"
            hint="Manage position rates and supervisor bump"
          />
        )}
      </div>
    </div>
  );
}